export abstract class ConfirmationService {
  abstract showConfirmation(message: String): boolean
}
